import { styled } from '@mui/material/styles';

import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { createFilterOptions } from '@mui/material/Autocomplete';

import theme from '../../theme';

const COLOR_OUTLINED_GREY = theme.palette.grey.w300;

const inputStyle = {
  width: '100%'
}

const nameInputStyle = {
  height: '52px',
  padding: '0 8px'
}

export const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
});

export const CustomFormLabel = styled('label')(({ theme }) => ({
  display: 'block',
  marginBottom: '8px',

  '& span': {
    display: 'inline-block',
    marginLeft: '4px',
    color: theme.palette.warning.main
  }
}))

export const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
  '&.MuiInputLabel-root': {
    marginTop: '-6px',

    '&.Mui-focused': {
      marginTop: 0,
    },

    '&.MuiInputLabel-shrink': {
      marginTop: 0,
    }
  }
}))

export const OutlinedGreyTextInput = styled('OutlinedInput')(({ theme }) => ({
  width: '100%',
}))

export const TextFieldCleanStyle = styled(TextField)(({ theme }) => ({
  flex: 1,
  minWidth: '30%',

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },

  '& .MuiOutlinedInput-input': {
    height: '22px',
    padding: 0,
    border: 'none',
  }
}))

export const TextFieldBlueMain = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.facebook.main,
    },
  },
}))

export const TextFieldOrangeMain = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.google.main,
    },
  },
}))

export const TextFieldGreenMain = styled(TextField)(({ theme }) => ({
  // '& label.Mui-focused': {
  //   color: theme.palette.media.line.main,
  // },
  // '& .MuiInput-underline:after': {
  //   borderBottomColor: theme.palette.media.line.main,
  // },
  '& .MuiOutlinedInput-root': {
    //文字框顏色
    // '& fieldset': {
    //   borderColor: 'red',
    // },
    //滑入框顏色
    // '&:hover fieldset': {
    //   borderColor: 'yellow',
    // },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.line.main,
    },
  },
}))

export const SearchInput = styled(OutlinedInput)(({ media }) => {
  let mainColor;

  if (media === 'FACEBOOK') {
    mainColor = theme.palette.facebook.main;
  } else if (media === 'GOOGLE') {
    mainColor = theme.palette.google.main;
  } else if (media === 'LINE') {
    mainColor = theme.palette.line.main;
  } else {
    mainColor = theme.palette.system.main;
  }

  return {
    '& .MuiInputBase-input': {
      paddingLeft: 0,
    },
    "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
      borderColor: mainColor
    }
  }
})

export const SearchInputBlueMain = styled(OutlinedInput)(({ theme }) => ({
  '& .MuiInputBase-input': {
    paddingLeft: 0,
  },
  "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.facebook.main,
  }
}))

export const SearchInputOrangeMain = styled(OutlinedInput)(({ theme }) => ({
  '& .MuiInputBase-input': {
    paddingLeft: 0,
  },
  "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.google.main,
  }
}))

export const SearchInputGreenMain = styled(OutlinedInput)(({ theme }) => ({
  '& .MuiInputBase-input': {
    paddingLeft: 0,
  },
  // "& .MuiOutlinedInput-notchedOutline": {
  //   borderColor: "red",
  // },
  "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.line.main,
  }
}))

export const AutocompleteBlueMain = styled(Autocomplete)(({ theme }) => ({
  '& .MuiChip-root': {
    backgroundColor: theme.palette.facebook.main,
  }
}))

export const AutocompleteOrangeMain = styled(Autocomplete)(({ theme }) => ({
  '& .MuiChip-root': {
    backgroundColor: theme.palette.google.main,
  }
}))

export const AutocompleteGreenMain = styled(Autocomplete)(({ theme }) => ({
  '& .MuiChip-root': {
    backgroundColor: theme.palette.line.main,
  }
}))